<div class="custom-domain-initial-container">
  <div class="custom-domain-header">
    <div class="title">Custom domain</div>
    <div class="subtitle">Add your custom domain to create your clients’ websites with a branded URL.</div>
  </div>
  <div class="custom-domain-body">
    <div class="custom-domain-info-line">
      <div class="line-title">Current domain</div>
      <div class="line-value">{{domain}}</div>
    </div>
    <div class="line"></div>
    <div class="custom-domain-info-line">
      <div class="line-title">Your client sites’ URL example</div>
      <div class="line-value"><span>{{clientUrl}}</span>{{domain}}</div>
    </div>
  </div>
  <div class="custom-domain-actions">
    <div class="custom-domain-actions-header">
      <div class="title">Add your custom domain</div>
      <div class="subtitle">New websites will use the new domain while existing ones will stay unchanged.</div>
    </div>
    <div class="custom-domain-actions-button">
      @if(showUpgrade){
      <button class="ds-btn-black ds-btn-ms m" (click)="showAPIUpgradePopup()">
        <i class="db-icon db-icon-ds-diamond-new"></i>
        <span>Upgrade</span>
      </button>
      } @else if (showActions){
      <button class="ds-btn-black small" (click)="onAddDomain.emit()">
       <span>Add domain</span>
      </button>
      }
    </div>
  </div>
</div>
